module.exports = __webpack_public_path__ + "img/PL08407.91c03f7b.png";